<script setup>
import { BFormGroup } from 'bootstrap-vue-next';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

defineProps({
  availableLanguages: {
    type: Array,
    required: true,
  },
});

const selectedLanguages = defineModel('selectedLanguages', {
  type: Array,
  required: true,
});
</script>

<template>
  <BFormGroup
    label="Languages"
    class="mb-3"
  >
    <VueSelect
      v-model="selectedLanguages"
      multiple
      deselect-from-dropdown
      :close-on-select="false"
      :options="availableLanguages"
      placeholder="Add a language by name, for example Ruby"
    >
      <template #no-options="{ search, searching }">
        <span v-if="searching && search">
          No issues found for language "{{ search }}"
        </span>
        <span v-else>
          No languages available
        </span>
      </template>
    </VueSelect>
  </BFormGroup>
</template>
